import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeft, Loader2 } from 'lucide-react';

import { clearCsAuth } from '@/utils/store';
import { resetPasswordApi } from '@/api/csResetPassword';
import styles from './index.module.css';

export default function CsRestPassword() {
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const isFormValid = password.length > 0 && confirmPassword.length > 0;

  const handleBack = () => {
    // 返回客服工作台并定位到「我的」tab
    navigate('/csHome', {
      state: { returnTab: 'mine' },
      replace: true,
    });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    if (password.length < 6) {
      setError('密码长度不能少于6位');
      return;
    }
    if (password !== confirmPassword) {
      setError('两次输入的密码不一致');
      return;
    }

    setLoading(true);

    try {
      // 拦截器已确认 code==='200'，直接视为成功
      await resetPasswordApi({ password });
      // 清除旧 token，防止 CsLogin 页面的已登录重定向把用户踢回 csHome
      clearCsAuth();
      console.log('重置密码成功');
      navigate('/csLogin', { replace: true });
    } catch (err) {
      // 业务失败统一走 catch，err.message 即为后端 msg
      console.log('重置密码失败', err instanceof Error ? err.message : '重置失败');
      setError(err instanceof Error ? err.message : '重置失败，请重试');
    } finally {
      console.log('重置密码 finally');
      setLoading(false);
    }
  };

  return (
    <div className={styles.container}>
      {/* 头部区域：导航 + 提示文字 */}
      <div className={styles.header}>
        {/* 顶部导航栏 */}
        <div className={styles.navBar}>
          <button
            type="button"
            className={styles.backBtn}
            onClick={handleBack}
            aria-label="返回"
          >
            <ChevronLeft size={20} className={styles.backIcon} />
          </button>
          <span className={styles.navTitle}>重置密码</span>
        </div>

        {/* 提示文字 */}
        <div className={styles.tipWrap}>
          <span className={styles.tipText}>请输入新的密码</span>
        </div>
      </div>

      {/* 主体内容区：表单 */}
      <form className={styles.main} onSubmit={handleSubmit}>
        <input
          className={styles.input}
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="请输入"
          autoComplete="new-password"
        />

        <input
          className={styles.input}
          type="password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          placeholder="请再次输入"
          autoComplete="new-password"
        />

        {error && <div className={styles.errorMsg}>{error}</div>}

        <button
          type="submit"
          className={`${styles.submitBtn} ${!isFormValid || loading ? styles.disabled : ''}`}
          disabled={!isFormValid || loading}
        >
          {loading ? <Loader2 size={20} className={styles.spin} /> : '确定'}
        </button>
      </form>
    </div>
  );
}
